import { createStore } from "redux";
import { mainReducer } from "./reducers/mainReducer";

const MainStore = createStore(mainReducer);

export default MainStore;